import { generalHrefHoc } from './GeneralHrefComponent';
import ProductHrefAdmin from './ProductHrefAdmin';
import {adventureComponentTypes} from "../../adventures/constants";

const getAdventureCategory = (adventure) => {
    if (adventure.is_camp && !adventure.is_kids) return adventureComponentTypes.camps;
    if (adventure.is_charter) return adventureComponentTypes.charters;
    if (adventure.is_kids && !adventure.is_camp) return adventureComponentTypes.kidsAdv;
    if (adventure.is_kids && adventure.is_camp) return adventureComponentTypes.kidsInt;

    return adventureComponentTypes.adventures;
}

const ArrivalHrefAdmin = ({ product, getParentEntry, productUrl, ...rest }) => {
  const linkFun = async (preparedProductFunc) => {
    let preparedProduct = await preparedProductFunc();
    const adventure = await getParentEntry(product ? product.adventure_id : preparedProduct.adventure_id.id);
    let adventureCategory = getAdventureCategory(adventure);

    if (preparedProduct.is_school) {
      return `/school/practices/view/${adventure.url}/${preparedProduct.url}`;
    }

    return `/${adventureCategory}/view/${adventure.url}/${productUrl || product?.url}`;
  }

  return <ProductHrefAdmin {...rest} linkFun={linkFun} product={product} />
}

const arrivalHrefHoc = (Component) => (props) => <Component
  {...props}
  name={props.linkName || 'заезд'}
  parentEndpoint='adventures'
  endpoint='arrivals'
/>

export default arrivalHrefHoc(generalHrefHoc(ArrivalHrefAdmin));